"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by nina.kirakosyan on 11/18/2020.
 */
var core_1 = require("@angular/core");
var tooltip_configs_model_1 = require("./tooltip-configs.model");
require("./sis-ng-tooltip.component.css");
var controls_translation_service_1 = require("../shared/controls-translation.service");
/**
 * Tooltip component with simple text or dynamic content via template - generated from sisTooltip directive.
 */
var SisNgTooltipComponent = /** @class */ (function () {
    function SisNgTooltipComponent(translationService, chDetRef) {
        this.translationService = translationService;
        this.chDetRef = chDetRef;
        /**
         * Flag to draw tooltip title.
         * @type {boolean}
         */
        this.showTitle = false;
        /**
         * Flag to show tooltip "don't show again" checkbox.
         * @type {boolean}
         */
        this.showDisableCheckbox = false;
        /**
         * Flag to show button to close tooltip from inside..
         * @type {boolean}
         */
        this.showCloseButton = false;
        /**
         * Classes to be passed to the tooltip. Supports the same syntax as ngClass.
         */
        this.tooltipClass = '';
        /**
         * Emits the change of hovering when mouse entering/leaving the tooltip.
         * @type {EventEmitter<boolean>}
         */
        this.onHoverChange = new core_1.EventEmitter();
        /**
         * Emits the change of checkbox value.
         * @type {EventEmitter<boolean>}
         */
        this.onCheckboxClicked = new core_1.EventEmitter();
        /**
         * Emits the close tooltip button click.
         * @type {EventEmitter<boolean>}
         */
        this.onCloseAction = new core_1.EventEmitter();
        /**
         * Default title for the tooltip.
         */
        this.defaultTitle = 'Tips and tricks';
        /**
         * SisTooltipPosition class holder for tooltip positioning strategy configs.
         */
        this.strategy = tooltip_configs_model_1.SisTooltipPosition;
    }
    Object.defineProperty(SisNgTooltipComponent.prototype, "placementType", {
        /**
         * Placement option setter
         * @type {string}
         */
        set: function (val) {
            this.placement = val;
            this.chDetRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Tooltip Mouse Enter event.
     */
    SisNgTooltipComponent.prototype.enter = function () {
        this.onHoverChange.emit(true);
    };
    /**
     * Tooltip Mouse Leave event.
     */
    SisNgTooltipComponent.prototype.leave = function () {
        this.onHoverChange.emit(false);
    };
    SisNgTooltipComponent.prototype.ngOnInit = function () {
        if (this.size == 'x-small' || this.size == 'small' || this.size == 'medium') {
            this.showTitle = false;
            this.showDisableCheckbox = false;
            this.showCloseButton = false;
        }
        if (this.size == 'x-small') {
            this.contentTemplate = null;
        }
    };
    SisNgTooltipComponent.prototype.onCheckToggle = function (value) {
        this.onCheckboxClicked.emit(value);
    };
    SisNgTooltipComponent.prototype.getMessage = function (key) {
        return this.translationService && this.translationService.getMessage(key);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "text", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", core_1.TemplateRef)
    ], SisNgTooltipComponent.prototype, "contentTemplate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisNgTooltipComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "checkboxText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "buttonText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisNgTooltipComponent.prototype, "showTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisNgTooltipComponent.prototype, "showDisableCheckbox", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisNgTooltipComponent.prototype, "showCloseButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "size", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisNgTooltipComponent.prototype, "placementType", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisNgTooltipComponent.prototype, "tooltipClass", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisNgTooltipComponent.prototype, "onHoverChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisNgTooltipComponent.prototype, "onCheckboxClicked", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisNgTooltipComponent.prototype, "onCloseAction", void 0);
    __decorate([
        core_1.HostListener('mouseenter'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SisNgTooltipComponent.prototype, "enter", null);
    __decorate([
        core_1.HostListener('mouseleave'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SisNgTooltipComponent.prototype, "leave", null);
    SisNgTooltipComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-ng-tooltip',
            template: require('./sis-ng-tooltip.component.html'),
        }),
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [controls_translation_service_1.ControlsTranslationService,
            core_1.ChangeDetectorRef])
    ], SisNgTooltipComponent);
    return SisNgTooltipComponent;
}());
exports.SisNgTooltipComponent = SisNgTooltipComponent;
//# sourceMappingURL=sis-ng-tooltip.component.js.map